


<app-nav-bar *ngIf="showNavBar"></app-nav-bar>
<div [@routeAnimations]="prepareRoute(outlet)" >
    <router-outlet #outlet="outlet"></router-outlet>
  </div>